// extracted by mini-css-extract-plugin
export default {"lists-box":"lists-box__z9PX6","radio":"radio__s-g+R","list-name":"list-name__ZqHNZ","list-label":"list-label__KBx1n"};